if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      };
      this.mql = window.matchMedia('(min-width: 750px)');
      this.hoverPreviewTimer = null;
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        const button = mediaToSwitch.querySelector('button');
        if (!button) return;

        button.addEventListener('click', this.handleThumbnailClick.bind(this, mediaToSwitch));

        const thumbRail = mediaToSwitch.dataset.thumbRail || mediaToSwitch.dataset.thumRail;
        if (thumbRail === 'video') return;

        mediaToSwitch.addEventListener('pointerenter', () => {
          if (!this.mql.matches) return;
          window.clearTimeout(this.hoverPreviewTimer);
          this.hoverPreviewTimer = window.setTimeout(() => {
            this.setActiveMedia(mediaToSwitch.dataset.target, false);
          }, 45);
        });
        mediaToSwitch.addEventListener('pointerleave', () => {
          window.clearTimeout(this.hoverPreviewTimer);
        });
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    zoomModalEl() {
      const id = this.dataset.sectionId;
      if (!id) return null;
      return document.getElementById(`ProductZoomModal-${id}`);
    }

    handleThumbnailClick(mediaToSwitch, event) {
      event.preventDefault();
      event.stopPropagation();
      window.clearTimeout(this.hoverPreviewTimer);

      const zoomModal = this.zoomModalEl();
      const thumbRailAttr = mediaToSwitch.dataset.thumbRail || mediaToSwitch.dataset.thumRail;
      const thumbRail = thumbRailAttr || 'image';
      const pureMediaId =
        mediaToSwitch.dataset.mediaNodeId ||
        (mediaToSwitch.dataset.target || '').split('-').pop() ||
        '';
      const main = zoomModal?.querySelector('[data-zoom-main]');
      const slideType = thumbRail === 'video' ? 'video' : 'image';
      let slideIndex = 0;
      if (main && pureMediaId) {
        const slides = [...main.querySelectorAll(`[data-zoom-slides="${slideType}"][data-media-id]:not(.hidden)`)];
        const idx = slides.findIndex((el) => String(el.dataset.mediaId) === String(pureMediaId));
        slideIndex = idx >= 0 ? idx : 0;
      }
      const button = mediaToSwitch.querySelector('button');

      if (thumbRail !== 'video') {
        this.setActiveMedia(mediaToSwitch.dataset.target, false);
      }

      if (zoomModal && button) {
        zoomModal.openedBy = button;
        zoomModal.show(slideIndex, thumbRail);
      }
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    isVerticalThumbRail() {
      const slider = this.elements.thumbnails?.querySelector('.slider--vertical-desktop');
      return Boolean(slider && this.mql.matches);
    }

    scrollToActive(activeMedia, mediaId) {
      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (!activeThumbnail) return;
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      });
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.remove('hidden');
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail?.parentElement?.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.scrollToActive(activeMedia, mediaId);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[data-target] button').forEach((element) => element.removeAttribute('aria-current'));
      const thumbBtn = thumbnail.querySelector('button');
      if (thumbBtn) thumbBtn.setAttribute('aria-current', 'true');

      const thumbSlider = this.elements.thumbnails.querySelector('slider-component');
      if (thumbSlider && typeof thumbSlider.isSlideVisible === 'function' && thumbSlider.isSlideVisible(thumbnail, 10)) return;

      if (this.isVerticalThumbRail()) {
        thumbnail.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        return;
      }

      if (thumbSlider?.slider) {
        thumbSlider.slider.scrollTo({ left: thumbnail.offsetLeft });
      } else {
        thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
